import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./contact.module.css";
import instaIcon from "../../assets/icons/insta.png";
import whatsappIcon from "../../assets/icons/whatsapp.png";
// import OfficeImage from "@assets/images/office.jpg"; // Ref commented out or removed

const InfoDetail = () => {
  const [imageUrl, setImageUrl] = useState("");

  // Google Drive Config
  const folderId = "1T4wfz3BTbs0urjFBhSk-s5eFcDQ6iflQ";
  const apiKey = "AIzaSyAAgFvKs3Vo5nuo_bkIY1ePkNqNsSmB33g";

  useEffect(() => {
    axios
      .get(
        `https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents and mimeType contains 'image/'&fields=files(id)&key=${apiKey}`
      )
      .then((res) => {
        if (res.data.files.length > 0) {
          setImageUrl(
            `https://drive.google.com/thumbnail?id=${res.data.files[0].id}&sz=w2000`
          );
        }
      })
      .catch((err) => console.error("Error fetching image from Drive:", err));
  }, []);

  return (
    <section className={styles.contactSection}>
      <div className={styles.container}>
        <div className={styles.wrapper}>

          {/* Left Image Section */}
          <div className={styles.imageBox}>
            {imageUrl && <img src={imageUrl} alt="Office" />}
          </div>

          {/* Right Content Section */}
          <div className={styles.contentBox}>
            <h2>CONTACT US</h2>

            <div className={styles.infoBlock}>
              <h4>ADDRESS</h4>
              <p>
                AA Block, Sector I, Bidhannagar, <br></br>Kolkata, West Bengal  PIN-700064
              </p>
            </div>

            <div className={styles.infoBlock}>
              <h4>PHONE</h4>
              <h4>+91 9088887799</h4>
            </div>
            <div className={styles.infoBlock}>
              <h4>MONDAY - FRIDAY</h4>
              <h4>11:00AM -7:00PM</h4>
            </div>

            <div className={styles.infoBlock}>
              <h4>EMAIL</h4>
              <a href="mailto:info@9griddesign.com" style={{ textTransform: 'lowercase' }}>
                info@9griddesign.com
              </a><br></br>
              <a href="mailto:info.9griddesign@gmail.com" style={{ textTransform: 'lowercase' }}>
                info.9griddesign@gmail.com
              </a>

              <div className={styles.socialRow}>
                <a href="https://www.instagram.com/9griddesign" target="_blank" rel="noopener noreferrer">
                  <img src={instaIcon} alt="Instagram" />
                </a>
                <a href="https://wa.me/919088887799" target="_blank" rel="noopener noreferrer">
                  <img src={whatsappIcon} alt="WhatsApp" />
                </a>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default InfoDetail;
